'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UIPopoverBody;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function UIPopoverBody(_ref) {
  var children = _ref.children,
      className = _ref.className,
      flush = _ref.flush;

  return _react2.default.createElement(
    'div',
    {
      className: (0, _classNames2.default)('uiPopoverBody', 'private-popover__body', { 'private-popover__body--flush': flush }, className)
    },
    children
  );
}

UIPopoverBody.propTypes = {
  children: _react.PropTypes.node,
  className: _react.PropTypes.string,
  flush: _react.PropTypes.bool
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1755/js/tooltip/UIPopoverBody.js
// module id = 949
// module chunks = 2 3